export function isTablet() {
    return window.innerWidth > 600;
}

export function isDesktop() {
    return window.innerWidth > 768;
}

export function isHuge() {
    return window.innerWidth > 2000;
}

export function isLarge() {
    return window.innerWidth > 1280;
}